import React from "react";
import { Loader } from "../Loader/Loader";
import { motion } from "framer-motion";
import { LogoutOutlined } from "@ant-design/icons";
import { Grid } from "antd";

const { useBreakpoint } = Grid;
const More = ({ loader, setCollapsed, setOpen }) => {

  const screens = useBreakpoint()


  const handleNavigate = () => {
    localStorage.clear();
    window.location.href = "https://login.pcgroup.ltd/";
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          {screens.lg && <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.3 }}
          >
            <div className="display-5 p-20 trad-pos">
              <div className="side-title">More Items</div>
              <div
                className="cursor nonea3"
                onClick={() => setCollapsed(true)}
                id="cs"
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z"
                    fill="#82858E"
                    stroke="#82858E"
                    stroke-width="1.5294"
                  />
                </svg>
              </div>
            </div>
          </motion.div>}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.3 }}
          >
            <div className="display-1 more-menu cursor" id="cs">
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.0002 0.999939C25.8367 0.999939 33.0002 8.16338 33.0002 16.9999C33.0002 25.8364 25.8367 32.9999 17.0002 32.9999C8.16368 32.9999 1.00024 25.8364 1.00024 16.9999C1.00024 8.16338 8.16368 0.999939 17.0002 0.999939ZM17.0002 22.4999C16.7241 22.4999 16.5002 22.7238 16.5002 22.9999C16.5002 23.2761 16.7241 23.4999 17.0002 23.4999C17.2764 23.4999 17.5002 23.2761 17.5002 22.9999C17.5002 22.7238 17.2764 22.4999 17.0002 22.4999ZM17.0002 9.37494C15.378 9.37494 14.0627 10.6901 14.0627 12.3124C14.0627 12.3815 14.1187 12.4374 14.1877 12.4374C14.2568 12.4374 14.3127 12.3815 14.3127 12.3124C14.3127 10.8282 15.516 9.62494 17.0002 9.62494C18.4845 9.62494 19.6877 10.8282 19.6877 12.3124C19.6877 13.0401 19.3988 13.701 18.928 14.1855L18.927 14.1845C18.8345 14.2798 18.7314 14.3842 18.6272 14.4882C18.2692 14.8454 17.8841 15.2323 17.5862 15.6152H17.5852C17.1814 16.134 16.8752 16.7138 16.8752 17.3749V18.4999C16.8752 18.569 16.9312 18.6249 17.0002 18.6249C17.0693 18.6249 17.1252 18.569 17.1252 18.4999V17.3749C17.1252 16.7946 17.3933 16.2686 17.7825 15.7685C18.0764 15.3908 18.4069 15.0637 18.7219 14.749C18.8481 14.623 18.9749 14.4949 19.1077 14.3583C19.6212 13.8294 19.9377 13.1078 19.9377 12.3124C19.9377 10.6901 18.6225 9.37494 17.0002 9.37494Z"
                  stroke="#9CA1A8"
                  stroke-width="2"
                />
              </svg>
              HELP
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.3 }}
          >
            <div className="display-1 more-menu cursor" id="cs">
              <svg
                width="27"
                height="31"
                viewBox="0 0 27 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.6119 22.3953C23.6396 20.7283 22.5087 18.2916 22.5087 15.7101V12.0733C22.5087 7.483 19.0989 3.68317 14.6821 3.0466V1.63781C14.6821 0.916458 14.0977 0.333374 13.3776 0.333374C12.6576 0.333374 12.0732 0.916458 12.0732 1.63781V3.0466C7.65506 3.68317 4.24656 7.483 4.24656 12.0733V15.7101C4.24656 18.2916 3.11562 20.7283 1.13157 22.4058C0.624141 22.8401 0.333252 23.4715 0.333252 24.1394C0.333252 25.3981 1.35724 26.4221 2.61602 26.4221H24.1392C25.398 26.4221 26.422 25.3981 26.422 24.1394C26.422 23.4715 26.1311 22.8401 25.6119 22.3953Z"
                  fill="#9499A0"
                />
                <path
                  d="M13.3748 30.3334C15.7371 30.3334 17.7133 28.6493 18.1673 26.42H8.58228C9.03622 28.6493 11.0124 30.3334 13.3748 30.3334Z"
                  fill="#9499A0"
                />
              </svg>
              ALERTS
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.3 }}
            onClick={handleNavigate}
          >
            <div className="display-1 more-menu cursor" id="cs">
              <LogoutOutlined
                style={{ color: "rgb(148, 153, 160)", fontSize: "21px" }}
              />
              Log Out
            </div>
          </motion.div>
        </>
      )}
    </>
  );
};

export default More;
